import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const UsersPanel = ({ orgUsers, currentOrg }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');

  const filtered = useMemo(() => {
    if (!searchTerm) return orgUsers;
    const q = searchTerm.toLowerCase();
    return orgUsers.filter(u =>
      (u.username && u.username.toLowerCase().includes(q)) ||
      (u.email && u.email.toLowerCase().includes(q))
    );
  }, [orgUsers, searchTerm]);

  return (
    <div className="home-org-users">
      <div className="home-org-users-header">
        <input
          type="search"
          placeholder={t('admin.search_placeholder')}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="home-org-users-search"
        />
        <span className="home-org-users-count">{filtered.length} users</span>
      </div>
      {filtered.length === 0 ? (
        <p className="home-empty-message">No users found</p>
      ) : (
        <div className="home-org-users-list">
          {filtered.map(user => {
            const role = user.roles?.[currentOrg] || '—';
            return (
              <div key={user.uid} className="home-org-user-card">
                <div className="home-org-user-avatar">
                  {(user.username || '?')[0].toUpperCase()}
                </div>
                <div className="home-org-user-info">
                  <span className="home-org-user-name">{user.username || 'Unnamed'}</span>
                  <span className="home-org-user-email">{user.email}</span>
                </div>
                <span className={`home-org-user-role home-role-${role.toLowerCase()}`}>{role}</span>
                <div className="home-org-user-meta">
                  <span className={`home-org-user-verified ${user.emailVerified ? 'ok' : 'warn'}`}>
                    {user.emailVerified ? '✓ verified' : '✗ unverified'}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UsersPanel;
